import { G } from '@/global'
import Vue from 'vue'
import AES from '@/lib/aes'

export enum ReportType {
    LoadPage = 'LOAD_PAGE',
    ClickStart = 'CLICK_START',
    TakePhoto = 'TAKE_PHOTO',
    LoadImage = 'LOAD_IMAGE',
    CheckImage = 'CHECK_IMAGE',
    ResolveImage = 'RESOLVE_IMAGE',
    UploadImage = 'UPLOAD_IMAGE',
}

interface IVersionInfo {
    appVersion: string
    abtestVersion: string
    abtestFlag: string
}

interface IEnvironment {
    userAgent: string
    platform: string
    language: string
    localID: string    // localStorage based ID
    sessionID: string  // sessionStorage based ID, reset when tab recreated
    processID: string  // process based ID, reset when page refreshed
}

export class Report {
    static create(type: ReportType, payload?: object) {
        return new Report(type, payload)
    }

    readonly version = G.REPORT_VERSION
    type: ReportType
    no?: number = 0  // session based report no
    timestamp?: number = 0
    versionInfo: IVersionInfo
    environment: IEnvironment
    payload?: object

    private constructor(type: ReportType, payload?: object) {
        this.type = type
        this.versionInfo = {
            appVersion: G.APP_VERSION,
            abtestVersion: G.ABTEST_VERSION,
            abtestFlag: G.abTest.flag,
        }
        this.environment = {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            language: navigator.language,
            localID: G.storage.localID,
            sessionID: G.storage.sessionID,
            processID: G.PROCESS_ID,
        }
        this.payload = payload
    }

    async send() {
        G.storage.eventReportNo += 1
        this.no = G.storage.eventReportNo
        this.timestamp = Date.now()

        let encryptData = { encryptData: AES.encrypt(JSON.stringify(this)) }
        await Vue.prototype.$http.post('/liveness/h5/v1/event-tracking-h5', encryptData)
    }
}

